import React from "react";

import background from "@cover/motorstoppen/background-1.svg";
import MotorStoppen from "../components/cover/animations/motorstoppen";
import articleSrc from '@assets/article.svg';

export const meta = {
  category: "stop",
  slug: "motorstoppen",
  id: "MotorStoppen",
  name: "motorstoppen",
  title: "Im Namen des Klimas",
  excerpt: {
    before:
      "Zu den wichtigsten alltäglichen Ursachen schädlicher Emissionen gehören Reisen mit dem Auto oder Flugzeug, aber auch Heizung und Strombedarf sowie das eigene Konsumverhalten.",
  },
  animation: MotorStoppen,
  cover: {
    background: {
      lg: background,
      sm: background,
    },
    alt: "Ein Mädchen meditiert. Man sieht sie jedoch kaum, da sie von dichtem Qualm umgeben ist, der aus dem Auspuff eines Autos kommt.",
  },
};

const MotorstoppenArticle = () => {
  return (
    <div>
      <p className="articleHighlight">
        Zu den wichtigsten alltäglichen Ursachen schädlicher Emissionen gehören
        Reisen mit dem Auto oder Flugzeug, aber auch Heizung und Strombedarf
        sowie das eigene Konsumverhalten. Jeder kann zum Klimaschutz beitragen!
        Getreu dem Motto «Vermeiden, reduzieren und kompensieren» können wir
        Verantwortung für unseren eigenen ökologischen Fußabdruck, d.h. auch für
        unsere CO2-Emissionen übernehmen.
			</p>
			<a href="https://www.klimaschutzstiftung-bw.de" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Mehr zur Klimaschutzstiftung
					<div className="articleLinkSource">
						klimaschutzstiftung-bw.de
					</div>
				</div>
			</a>
      <p className="articleQuestion">Tipps:</p>
      <ol className="articleList articleList--ordered">
        <li className="articleListItem">
          Carsharing statt eigenem Auto: Ein eigenes Auto ist nicht nur teuer,
          sondern auch klimaschädlich. Eine gute Alternative zum privaten Pkw
          ist daher die gemeinschaftliche Nutzung eines Fahrzeugs – sogenanntes
          Carsharing. Ein Carsharing-Auto ersetzt im Schnitt rund 10 Autos.
          Sofern das Auto nicht zum täglichen Pendeln benötigt wird, spart man
          mit Carsharing pro Jahr mehrere hundert Kilogramm CO2 und jede Menge
          Geld.
        </li>
        <li className="articleListItem">
          Öfter das Rad oder den ÖPNV nehmen: Noch klimafreundlicher ist der
          Verzicht auf Autofahrten und der Umstieg auf Fahrrad oder öffentliche
          Verkehrsmittel. Wer beispielsweise 1.000 Kilometer weniger mit dem
          Auto pro Jahr fährt, spart rund 100 Liter Benzin oder Diesel. Und das
          erspart der Atmosphäre ganze 250 Kilogramm CO2. Dabei spielt es keine
          Rolle, ob die Kilometer einer Langstrecke oder vieler kleiner Wege,
          die Sie auch mit dem Fahrrad erledigen können, eingespart werden.
        </li>
      </ol>
    </div>
  );
};

export default MotorstoppenArticle;
